/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* VAST tracker configuration for StackAdapt campaign ad
*/
export class V3StackAdaptVastTracker {
    /**
    * Tracker / VAST URL for the ad
    */
    'url'?: string;
    /**
    * Event type for the tracker. One of: 'start', 'firstQuartile', 'midpoint', 'thirdQuartile', 'complete'
    */
    'eventType'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "eventType",
            "baseName": "eventType",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptVastTracker.attributeTypeMap;
    }

    public constructor() {
    }
}

